import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { DataTableBackendPagination } from 'shared/ui/Table';
import { columnConfigDownloadPromo } from 'widgets/downloads/model';
import { downloadNotLoadedBonuses } from 'entities/downloads/bonuses/api/downloadNotLoadedBonuses';
import { useGetDownloadsBonusesMutation } from 'entities/downloads/bonuses/api';
import { mapDownloadBonusesToTableRenderType } from '../utils';

export const DownloadsBonusesTable = () => {
  const [downloadBonusesMethod, { data: downloadBonuses, error: downloadBonusesError }] =
    useGetDownloadsBonusesMutation();
  const [pagination, setPagination] = useState({
    rowsPerPage: 5,
    page: 0,
  });

  useEffect(() => {
    downloadBonusesMethod({
      upload_type: 'activity_bonuses',
      size: pagination.rowsPerPage,
      page: pagination.page + 1,
    }).then((res) => {
      if ((res as { error: FetchBaseQueryError }).error) {
        toast.error('Произошла ошибка при загрузке данных', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: Symbol('toastId').toString(),
        });
      }
    });
  }, [pagination]);

  const handleDownloadRow = (idx: number) => {
    downloadNotLoadedBonuses({
      url: downloadBonuses?.items[idx].err_file ?? '',
      fileName: downloadBonuses?.items[idx].file_name ?? '',
    });
  };

  const handleUpdateTable = () => {
    downloadBonusesMethod({
      upload_type: 'activity_bonuses',
      size: pagination.rowsPerPage,
      page: 1,
    }).then(() => {
      if (!downloadBonusesError) {
        toast.success('Данные успешно обновлены', {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error('Произошла ошибка при загрузке данных', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };

  return (
    <DataTableBackendPagination
      title="Акции - Бонусы"
      data={downloadBonuses ? mapDownloadBonusesToTableRenderType(downloadBonuses?.items) : []}
      total={downloadBonuses?.total ?? 0}
      pagination={pagination}
      setPagination={setPagination}
      columnConfig={columnConfigDownloadPromo}
      emptyListTitle="Нет загрузок для отображения"
      onDownloadRow={handleDownloadRow}
      onUpdateTable={handleUpdateTable}
      buttonsController
    />
  );
};
